import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react'
import { useTablePipeline, features, BaseTable } from 'ali-react-table-yet'
import { cn } from '@/lib/utils'
import { useState } from 'react'

const VirtualizedDataTable = forwardRef((props, ref) => {
  const [lastClickedRow, setLastClickedRow] = useState(-1)
  const tableRef = useRef(null)
  const { primaryKey = 'install_date', ...restProps } = props

  useImperativeHandle(ref, () => ({
    scrollToStart: () => {
      if (tableRef.current) {
        const artTableBody = tableRef.current.querySelector('.art-table-body')
        if (artTableBody) {
          artTableBody.scrollTo({
            left: 0,
            behavior: 'smooth',
          })
        }
      }
    },
    scrollToEnd: () => {
      if (tableRef.current) {
        const artTableBody = tableRef.current.querySelector('.art-table-body')
        if (artTableBody) {
          artTableBody.scrollTo({
            left: artTableBody.scrollWidth,
            behavior: 'smooth',
          })
        }
      }
    },
  }))

  const pipeline = useTablePipeline().input({ ...restProps, primaryKey }).primaryKey(primaryKey)

  const getBgColor = (rowIndex) => {
    const baseBgColor = rowIndex % 2 !== 0 ? 'bg-gray-200' : 'bg-white'
    const bgColor = lastClickedRow === rowIndex ? 'bg-yellow-100' : baseBgColor
    return bgColor
  }

  const rowPropsGetter = (row, rowIndex) => {
    const bgColor = getBgColor(rowIndex)
    return {
      style: {
        '--bgcolor': cn(bgColor),
        '--hover-bgcolor': cn('bg-yellow-100'),
      },
      className: cn(bgColor, 'hover:bg-yellow-100'),
    }
  }

  const rowHightlightSelected = (_, rowIndex) => ({
    onClick: () => {
      setLastClickedRow(rowIndex)
    },
  })

  const lockedColumnsStyle = (pipeline) => {
    const columns = pipeline.getColumns().map((column) => {
      column.getCellProps = (_value, _record, rowIndex) => {
        return {
          style: {
            backgroundColor: column.lock
              ? 'hsl(var(--muted)) !important'
              : getBgColor(rowIndex),
          },
        }
      }
      column.headerCellProps = {
        className: 'text-right text-base text-black',
      }
      return column
    })
    pipeline.columns(columns)
    return pipeline
  }

  pipeline
    .appendRowPropsGetter(rowPropsGetter)
    .appendRowPropsGetter(rowHightlightSelected)
    .use(lockedColumnsStyle)
  return (
    <div ref={tableRef} className="h-full">
      <BaseTable
        {...pipeline.getProps()}
        style={{
          height: '100%',
          '--header-bgcolor': 'hsl(var(--muted))',
        }}
      />
    </div>
  )
})

export default VirtualizedDataTable
